export class CardItem {
  name: string;
  isHighlight: boolean;
  notAvailable: boolean;
  showTooltip: boolean;
  url?: string;

  constructor(
    name: string,
    isHighlight = false,
    notAvailable = false,
    showTooltip = false,
    url?: string
  ) {
    this.name = name;
    this.isHighlight = isHighlight;
    this.notAvailable = notAvailable;
    this.showTooltip = showTooltip;
    this.url = url;
  }
}
